module.exports = __webpack_public_path__ + "static/media/lidinei.cadd29de.jpg";